(function() {
  var loaded = false;

  var activityEvents = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];

  function activateDeferred() {
    if (loaded) return;
    loaded = true;

    activityEvents.forEach(function(name) {
      window.removeEventListener(name, activateDeferred, false);
    });

    document.querySelectorAll('script[data-src]').forEach(function(el) {
      el.src = el.dataset.src;
      delete el.dataset.src;
    });

    document.querySelectorAll('link[data-href]').forEach(function(el) {
      el.href = el.dataset.href;
      delete el.dataset.href;
    });

    document.querySelectorAll('.deferredScript').forEach(function(el) {
      el.type = 'text/javascript';
    });

    setTimeout(function() {
      document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
      document.dispatchEvent(new CustomEvent('StartKernelLoading'));
    }, 400);
  }

  activityEvents.forEach(function(name) {
    window.addEventListener(name, activateDeferred, { once: true, passive: true });
  });

  window.addEventListener('load', function() {
    setTimeout(activateDeferred, 9000);
  });
})();
